import React, { ReactNode } from "react";
import styles from "./TitleText.module.css";
import clsx from "clsx";

export enum TitleTextSize {
  heading1 = "heading1",
  heading2 = "heading2",
  heading3 = "heading3",
  heading4 = "heading4",
}

interface TitleTextProps {
  children: ReactNode;
  size?: TitleTextSize;
  shadow?: boolean;
}

const TitleText: React.FC<TitleTextProps> = ({
  children,
  size = TitleTextSize.heading1,
  shadow = false,
  ...props
}) => {
  return (
    <span
      {...props}
      className={clsx(
        styles["title-text"],
        { [styles[size]]: size },
        shadow && styles["shadow"]
      )}
    >
      {children}
    </span>
  );
};

export default TitleText;
